import axios from 'axios'
import CreateGraduationCard from './dto/CreateGraduationCard'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedGraduationCardResultRequestDto} from './dto/PagedGraduationCardResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllGraduationCards from './dto/GetAllGraduationCards'
import UpdateGraduationCard from './dto/UpdateGraduationCard'
import GetGraduationCard from './dto/GetGraduationCard'
import UpdateBatchGraduationCardStatus from './dto/UpdateBatchGraduationCardStatus'
import UpdateBatchGraduationDeliveryType from './dto/UpdateBatchGraduationDeliveryType'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Card/Create`
export const URL_DELETE = `${API_URL}/Card/Delete`
export const URL_GET = `${API_URL}/Card/Get`
export const URL_GET_ALL = `${API_URL}/Card/GetPagedAll`
export const URL_GET_BY_GRADUATED_ID = `${API_URL}/Card/GetByGraduatedId`
export const URL_UPDATE = `${API_URL}/Card/Update`
export const URL_UPDATE_STATUS = `${API_URL}/Card/UpdateCardStatus`
export const URL_UPDATE_BATCH_STATUS = `${API_URL}/Card/UpdateBatchCardStatus`
export const URL_UPDATE_BATCH_DELIVERY_TYPE = `${API_URL}/Card/UpdateBatchCardDeliveryType`
export const URL_GET_BY_USER_ID = `${API_URL}/Card/GetCardByUserIdAll`

export function onCreateGraduationCard(
  createGraduationCard: CreateGraduationCard
): Promise<boolean> {
  return axios.post(URL_CREATE, createGraduationCard)
}

export function onDeleteGraduationCard(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

/*export function onGetGraduationCardsByGraduationId(user: EntityDto): Promise<GetGraduationCard> {
  return axios.get(URL_GET_BY_GRADUATED_ID, {params: user})
}*/

export function onGetGraduationCard(entityDto: EntityDto): Promise<GetGraduationCard> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllGraduationCards(
  pagedFilterAndSortedRequest: PagedGraduationCardResultRequestDto
): Promise<PagedResultDto<GetAllGraduationCards>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onGetGraduationCardByGraduatedId(
  graduatedId: EntityDto
): Promise<GetAllGraduationCards> {
  return axios.get(URL_GET_BY_GRADUATED_ID, {params: graduatedId})
}

export function onGetGraduationCardByUserId(
  userId: EntityDto
): Promise<GetAllGraduationCards> {
  return axios.get(URL_GET_BY_USER_ID)
}

export function onUpdateGraduationCard(
  updateGraduationCardInput: UpdateGraduationCard
): Promise<boolean> {
  return axios.put(URL_UPDATE, updateGraduationCardInput)
}

export function onUpdateGraduationCardStatus(
  updateGraduationCardInput: UpdateGraduationCard
): Promise<boolean> {
  return axios.put(URL_UPDATE_STATUS, updateGraduationCardInput)
}

export function onUpdateBatchGraduationCardStatus(
  updateBatchGraduationCardInput: UpdateBatchGraduationCardStatus
): Promise<boolean> {
  return axios.put(URL_UPDATE_BATCH_STATUS, updateBatchGraduationCardInput)
}
export function onUpdateBatchGraduationDeliveryType(
  updateBatchGraduationCardInput: UpdateBatchGraduationDeliveryType
): Promise<boolean> {
  return axios.put(URL_UPDATE_BATCH_DELIVERY_TYPE, updateBatchGraduationCardInput)
}
